import React from "react"
import { COMPANIES } from "./constants"
import KimDentalMapDetailMobile from "./KimDentalMapDetailMobile"
import CdFinanceMapDetailMobile from "./CdFinanceMapDetailMobile"
import CropinMapDetailMobile from "./CropinMapDetailMobile"
import SunseapMapDetailMobile from "./SunseapMapDetailMobile"
import V2FoodMapDetailMobile from "./V2FoodMapDetailMobile"

const MapDetailMobile = props => {
  return (
    <>
      {props.currentlySelectedCompany === COMPANIES.cropIn && (
        <CropinMapDetailMobile />
      )}
      {props.currentlySelectedCompany === COMPANIES.cdFinance && (
        <CdFinanceMapDetailMobile />
      )}
      {props.currentlySelectedCompany === COMPANIES.kimDental && (
        <KimDentalMapDetailMobile />
      )}
      {props.currentlySelectedCompany === COMPANIES.sunseap && (
        <SunseapMapDetailMobile />
      )}
      {props.currentlySelectedCompany === COMPANIES.v2Food && (
        <V2FoodMapDetailMobile />
      )}
    </>
  )
}

export default MapDetailMobile
